import { Box, ModuleBase, Text, Stack, ResponsiveImage, Link } from '@/components';
import classNames from 'classnames';
import { fadeIn } from '@/animations';
import { SideBySideModuleModel } from './SideBySideModule';

const ICPTab = (data: SideBySideModuleModel) => {
  const { alignment, preTitle, title, description, link1, cards, image } = data.props;

  return (
    <ModuleBase
      noPadding
      data={data}
      className={classNames(
        'ICPTab relative flex flex-col-reverse items-center lg:flex-row',
        alignment === 'Right' ? 'justify-end' : 'justify-start',
      )}
    >
      {image && (
        <Stack className="relative h-[380px] w-full overflow-hidden sm:h-[500px] lg:min-h-[650px] lg:w-1/2 xl:min-h-[700px]">
          {image && image.desktopImage && (
            <ResponsiveImage
              animation={fadeIn}
              image={image.desktopImage}
              widths={{ xs: 425, sm: 650, md: 758, lg: 512, xl: 720, xxl: 950 }}
              heights={{ xs: 380, sm: 500, md: 500, lg: 650, xl: 700, xxl: 700 }}
            />
          )}
          <Box className="absolute bottom-0 left-0 w-full bg-black/50 p-6 text-white lg:px-10 lg:py-14">
            <div className="text-style-h3" dangerouslySetInnerHTML={{ __html: description || '' }} />
            {link1 && (
              <Link
                className="btn primary btn-from-bg v2 !bg-yellow !border-yellow !text-green mt-10 hover:!border-white hover:!bg-transparent hover:!text-white lg:mt-8"
                link={link1}
              />
            )}
          </Box>
        </Stack>
      )}

      <div className="pointer-events-none left-0 flex w-full items-center pt-10 pb-5 lg:absolute lg:h-full lg:pt-0 lg:pb-0">
        <div
          className={classNames(
            'container flex lg:h-full lg:pt-18 lg:pb-12',
            alignment === 'Right' ? 'lg:justify-start' : 'lg:justify-end',
          )}
        >
          <Stack
            className={classNames(
              'pointer-events-auto flex w-full flex-col lg:w-1/2 lg:justify-between',
              alignment === 'Right' ? '' : 'lg:pl-9',
            )}
          >
            <div className="flex flex-col gap-5">
              {preTitle && <Text className="text-style-tag uppercase">{preTitle}</Text>}
              {title && (
                <Text
                  className="text-style-h3 pr-10 md:pr-20 lg:pr-0 xl:w-9/12"
                  dangerouslySetInnerHTML={{ __html: title }}
                />
              )}
            </div>
            <div className="w-full">
              <div className="mt-5 flex-col gap-5 lg:mt-10">
                {cards &&
                  cards.map((card, index) => (
                    <Box
                      key={index}
                      className="border-from-bg group flex flex-row items-center justify-between gap-1 border-b border-solid py-3 last:border-b-0 lg:py-4 lg:pr-9"
                    >
                      <div className="flex flex-col gap-1 xl:w-11/12">
                        <p className="text-style-h5 text-[14px] sm:text-[20px] md:text-[26px]">{card.title}</p>
                        <div className="text-style-body" dangerouslySetInnerHTML={{ __html: card.text || '' }} />
                      </div>
                    </Box>
                  ))}
              </div>
            </div>
          </Stack>
        </div>
      </div>
    </ModuleBase>
  );
};

export default ICPTab;
